import { useState } from "react";
import PdfViewer from "./PdfViewer";

export default function SectionPdfViewer({ sections }) {
    const [openSections, setOpenSections] = useState({});

    const toggleSection = (id) => {
        setOpenSections(prev => ({
            ...prev,
            [id]: !prev[id],
        }));
    };

    return (
        <div>
            {Object.entries(sections).map(([id, section]) => (
                <div key={id} style={styles.section}>
                    {/* Header */}
                    <div
                        style={styles.header}
                        onClick={() => toggleSection(id)}
                    >
                        {section.poolText}
                        <span>{openSections[id] ? "▲" : "▼"}</span>
                    </div>

                    {/* Body */}
                    {openSections[id] && (
                        <div style={styles.body}>
                            <PdfViewer fileUrl={section.pdfUrl} />
                        </div>
                    )}
                </div>
            ))}
        </div>
    );
}

const styles = {
    section: {
        borderBottom: "1px solid #ddd",
        marginBottom: 10,
    },
    header: {
        padding: 10,
        background: "#f5f5f5",
        cursor: "pointer",
        fontWeight: "bold",
        display: "flex",
        justifyContent: "space-between",
    },
    body: {
        padding: 10,
    },
};